import { createAsyncThunk } from "@reduxjs/toolkit";
import { type DayCloseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export interface CheckDayCloseParams {
  ambassadorId: string;
  businessDate: string;
}

/** Reports whether the day is already closed (drives the closed state on mount). */
export const checkDayClose = createAsyncThunk<
  boolean,
  CheckDayCloseParams,
  { dispatch: DayCloseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CHECK_DAY_CLOSE, async (params, { extra }) => {
  const summary = await extra.dayCloseRepo.getClose(params.ambassadorId, params.businessDate);
  return summary !== null;
});
